import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';

/**
 * @typedef {Object} Props
 * @property {Function} onError The function to call when an error occurs.
 * @property {Function} onAgentConnected The function to call when the agent is successfully connected.
 */

/**
 * Displays a dialog to verify the user's account for Genesys.
 *
 * @param {Props} props The props for the component.
 */
export function GenesysDialog(props) {
	/** Whether something is currently being loaded in the page. */
	const [loading, setLoading] = useState(false);

	/**
	 * Attempts to authorize the user with Genesys.
	 */
	useEffect(() => {
		authorizeGenesys();
	}, []);

	/**
	 * Checks if the user is already logged in to Genesys.
	 */
	async function authorizeGenesys() {
		setLoading(true);
		setTimeout(() => {
			props.onAgentConnected();
			setLoading(false);
		}, 1000);
	}

	return (
		<>
			{/* Loading */}
			{loading && (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100vh',
					}}
				>
					<CircularProgress
						variant="indeterminate"
						color="primary"
					></CircularProgress>
				</div>
			)}
		</>
	);
}
